import { render } from "./CustomerDialogRawData.vue?vue&type=template&id=65552188"
import script from "./CustomerDialogRawData.vue?vue&type=script&lang=js"
export * from "./CustomerDialogRawData.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__